// Fancyapps => Fancybox, Panzoom
import { Fancybox, Panzoom } from '@fancyapps/ui';
window.Fancybox = Fancybox;
window.Panzoom = Panzoom;

import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "@fancyapps/ui/dist/panzoom/panzoom.css";
